// src/components/PlantForm/constants.ts
export const steps = [
  'Basic Information', 
  'Classification', 
  'Description', 
  'Landscaping', 
  'Plant Care', 
  'Foliar Details', 
  'Floral Details', 
  'Images & Publish'
];

// Plant types for dropdown
export const plantTypes = [
  'Palm',
  'Succulent',
  'Fern',
  'Flowering',
  'Foliage',
  'Vine',
  'Herb',
  'Tree',
  'Shrub',
  'Other'
];

// Watering frequency options
export const wateringFrequencies = [
  { value: 1, label: 'Daily' },
  { value: 2, label: 'Every 2 days' },
  { value: 3, label: 'Every 3 days' },
  { value: 7, label: 'Weekly' },
  { value: 14, label: 'Bi-weekly' },
  { value: 30, label: 'Monthly' }
];

// Light requirement options
export const lightRequirements = [
  'Full Sun',
  'Partial Sun',
  'Shade',
  'Indirect Light',
  'Low Light'
];

// Classification and Characteristics options
export const plantDivisions = [
  'Angiosperms (Flowering Seed Plants) (Dicotyledon)',
  'Angiosperms (Flowering Seed Plants) (Monocotyledon)',
  'Gymnosperms (Non-Flowering Seed Plants)',
  'Pteridophytes (Ferns and Fern Allies)',
  'Bryophytes (Mosses and Liverworts)'
];

export const growthForms = [
  'Tree',
  'Shrub',
  'Herb',
  'Climber',
  'Epiphyte',
  'Aquatic'
];

export const lifespans = [
  'Annual',
  'Biennial',
  'Perennial'
];

export const nutritionModes = [
  'Autotrophic',
  'Parasitic',
  'Saprophytic'
];

// Biogeography options
export const habitats = [
  'Terrestrial',
  'Aquatic',
  'Epiphytic'
];

export const climateZones = [
  'Tropical',
  'Sub-Tropical / Monsoonal',
  'Temperate',
  'Mediterranean',
  'Arid / Desert'
];

// Landscaping Features options
export const plantFeatures = [
  'Ornamental Flowers',
  'Ornamental Foliage',
  'Ornamental Fruits',
  'Fragrant',
  'Edible',
  'Medicinal',
  'Shade-Providing'
];

export const landscapeUseOptions = [
  'General',
  'Hedging',
  'Screening',
  'Specimen',
  'Mass Planting',
  'Container',
  'Indoor',
  'Groundcover'
];

// Add other constants as needed
